import { NgForOf } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { Subscription } from 'rxjs';
import { BullhornFieldType } from '../../data-rules-model';
import { IActionFieldMeta, MetaDataService } from '../../meta-data.service';
import { BaseActionComponent } from '../base-action.component';

@Component({
  selector: 'app-action-stringformat',
  templateUrl: './stringformat.component.html',
  imports: [
    MatSelect,
    MatOption,
    ReactiveFormsModule,
    NgForOf
  ],
  styleUrls: ['../action.component.scss']
})
export class StringformatComponent extends BaseActionComponent implements AfterViewInit, OnDestroy {

  formatTypes = [];
  format = FormatType;
  formatSelected: FormControl;
  private formatSelectedSubscription: Subscription;
  private valueControlSubscription: Subscription;

  constructor(private formBuilder: FormBuilder, protected metaDataService: MetaDataService,  private cd: ChangeDetectorRef) {
    super(metaDataService);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.formatSelectedSubscription.unsubscribe();
    this.valueControlSubscription.unsubscribe();
    this.formGroup.removeControl('value');
    this.formGroup.addControl('value', new FormControl(null));
  }

  initialise(): void {
    this.setUpFormControls();
    if (!this.valueControl.value) {
      this.valueControl.setValue(StringformatComponent.getDefaultValue(this.destinationTypeControl.value));
    } else {
      this.formatSelected.setValue(this.valueControl.value);
      this.formGroup.setErrors(null);
    }
    this.formatTypes = Object.keys(FormatType);
  }

  ngAfterViewInit() {
    this.formatSelectedSubscription = this.formatSelected.valueChanges.subscribe(value => this.changevalue(value));
    this.valueControlSubscription = this.valueControl.valueChanges.subscribe(_ => this.valueControlValueChange());
    this.valueControlValueChange();

    setTimeout(() => {
      this.getMeta(this.destinationDescriptorControl.value)
        .subscribe((filteredMeta: IActionFieldMeta[]) => {
          const selField = filteredMeta.find(fm => fm.fieldName === this.destinationControl.value);
          this.sourceControl.setValidators(null);
          this.destinationControl.setValidators(Validators.required);
          this.destinationControlValueChange(selField);
        });
    }, 0);
    this.cd.detectChanges();
  }

  setUpFormControls(): void {
    this.formGroup.removeControl('value');
    this.formatSelected = new FormControl();

    this.formGroup.addControl('value', this.formatSelected);
  }

  protected destinationControlValueChange(selectedField: IActionFieldMeta): void {

    if (!selectedField) {
      this.valueControl.setValue(null);
      this.destinationTypeControl.setValue(null);
      this.destinationTypeControl.setValue(null);
      return;
    }

    if (this.destinationTypeControl.value !== selectedField.metaType)
      this.valueControl.setValue(StringformatComponent.getDefaultValue(selectedField.metaType));

    this.valueControl.setValidators(
      selectedField.metaType === BullhornFieldType.STRING
        ? null
        : Validators.required
    );
    this.destinationTypeControl.setValue(selectedField.metaType);
  }

  private static getDefaultValue(type: string): any {
    switch (type) {
      case 'STRING':
        return '';
      default:
        return null;
    }
  }

  changevalue(value: string): void {
   this.valueControl.setValue(value);
  }

  private valueControlValueChange(): void {
    if (this.formatSelected.value === null) {
      this.valueControl.setErrors({ invalid: true });
    }
  }
}

export enum FormatType {
  LOWER = 'Lower case',
  UPPER = 'Upper case',
  CAPITALISE = 'Capitalise first word',
  CAPITALISE_ALL = 'Capitalise all words'
}
